export const STORAGE = {
    TOKEN_KEY: 'token',
    USER_KEY: 'user',
    ACCEPT_REQUIRE_KEY: 'accept_require',
    DELIVERY_DATE_REQUIRED_KEY: 'delivery_date_required',
    REDIRECT_URL_KEY: 'redirect_url',
    FAVORITE_PRODUCT_ID_KEY: 'product_id_favorite',
    SAMPLE_ORDER_KEY: 'sample_order',
    EMAIL_KEY: 'email',
    FLOORING_COLLECTIONS_KEY: 'flooring_collections',
    WALLING_COLLECTIONS_KEY: 'walling_collections',
    PRODUCT_KEY :'selectedTypeId',
    GATHERCOCREDIT:'gathercoCredit',
    SEARCH_KEY: 'search',
    PRICE_LIST_SEARCH_KEY: 'price_list_filter',
    CREDIT_EARN_KEY: 'is_credit_earn_disabled'
}
